import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { 
  Shield,
  FileText,
  Users,
  Lock,
  Globe,
  Clock,
  Settings,
  Mail,
  Building2,
  Database,
  AlertTriangle,
  Bot
} from 'lucide-react';

export default function PrivacyPolicy() {
  const sections = [
    {
      id: 1,
      title: "Titolare del Trattamento",
      icon: Building2,
      content: `
        <p>Il Titolare del trattamento dei dati è:</p>
        <p><strong>Assietica Società Cooperativa – Società Benefit</strong></p>
        <ul>
          <li>Sede legale: [Indirizzo]</li>
          <li>Email: privacy@assietica.it</li>
          <li>PEC: [PEC]</li>
        </ul>
        <p>Il Titolare può essere contattato per qualsiasi informazione relativa al trattamento dei dati personali.</p>
      `
    },
    {
      id: 2,
      title: "Tipologie di Dati Raccolti",
      icon: Database,
      content: `
        <p><strong>Dati forniti volontariamente dall'utente:</strong></p>
        <ul>
          <li>Dati di registrazione: nome, cognome, email, password</li>
          <li>Dati dell'ente: denominazione, codice fiscale, indirizzo, contatti</li>
          <li>Dati di pagamento: gestiti tramite Stripe (non conserviamo dati carte)</li>
        </ul>
        <p><strong>Dati inseriti dall'utente nella piattaforma:</strong></p>
        <ul>
          <li>Anagrafiche volontari e soci</li>
          <li>Documenti caricati</li>
          <li>Dati di attività ed eventi</li>
          <li>Dati contabili</li>
        </ul>
        <p><strong>Dati raccolti automaticamente:</strong></p>
        <ul>
          <li>Indirizzo IP</li>
          <li>Tipo di browser e dispositivo</li>
          <li>Log di accesso e utilizzo</li>
          <li>Cookie tecnici</li>
        </ul>
      `
    },
    {
      id: 3,
      title: "Finalità del Trattamento",
      icon: FileText,
      content: `
        <p>I dati personali sono trattati per le seguenti finalità:</p>
        <p><strong>a) Erogazione del servizio (base giuridica: contratto)</strong></p>
        <ul>
          <li>Gestione dell'account utente</li>
          <li>Accesso e utilizzo della piattaforma</li>
          <li>Supporto tecnico e assistenza</li>
        </ul>
        <p><strong>b) Obblighi di legge (base giuridica: obbligo legale)</strong></p>
        <ul>
          <li>Adempimenti fiscali e contabili</li>
          <li>Risposta a richieste delle autorità</li>
        </ul>
        <p><strong>c) Miglioramento del servizio (base giuridica: legittimo interesse)</strong></p>
        <ul>
          <li>Analisi aggregate sull'utilizzo</li>
          <li>Sviluppo di nuove funzionalità</li>
          <li>Prevenzione abusi e sicurezza</li>
        </ul>
        <p><strong>d) Comunicazioni (base giuridica: contratto/consenso)</strong></p>
        <ul>
          <li>Comunicazioni di servizio (obbligatorie)</li>
          <li>Newsletter e aggiornamenti (su consenso)</li>
        </ul>
      `
    },
    {
      id: 4,
      title: "Responsabilità sui Dati di Terzi",
      icon: Users,
      content: `
        <p><strong>Importante:</strong> L'utente che inserisce dati di volontari, soci o altre persone nella piattaforma assume il ruolo di <strong>Titolare del trattamento</strong> per tali dati.</p>
        <p>L'utente è responsabile di:</p>
        <ul>
          <li>Acquisire i necessari consensi dagli interessati</li>
          <li>Fornire l'informativa privacy agli interessati</li>
          <li>Garantire la liceità del trattamento</li>
          <li>Rispondere alle richieste di accesso, rettifica, cancellazione</li>
        </ul>
        <p>Assietica agisce come <strong>Responsabile del trattamento</strong> (Data Processor) per i dati inseriti dall'utente, trattandoli esclusivamente per le finalità del servizio.</p>
        <p>Su richiesta, è disponibile un <strong>Data Processing Agreement (DPA)</strong> conforme all'art. 28 GDPR.</p>
      `
    },
    {
      id: 5,
      title: "Conservazione dei Dati",
      icon: Clock,
      content: `
        <p><strong>Dati dell'account:</strong></p>
        <ul>
          <li>Conservati per tutta la durata del rapporto contrattuale</li>
          <li>Dopo la cessazione: 10 anni per obblighi fiscali</li>
        </ul>
        <p><strong>Dati inseriti dall'utente (volontari, soci, ecc.):</strong></p>
        <ul>
          <li>Conservati finché l'utente non li elimina</li>
          <li>Dopo chiusura account: 30 giorni per permettere il recupero</li>
          <li>Export sempre disponibile prima della cancellazione</li>
        </ul>
        <p><strong>Log e dati tecnici:</strong></p>
        <ul>
          <li>Log di sicurezza: 12 mesi</li>
          <li>Dati analitici aggregati: 24 mesi</li>
        </ul>
        <p><strong>Backup:</strong></p>
        <ul>
          <li>I backup vengono conservati per 90 giorni</li>
          <li>Dopo la cancellazione dell'account, i dati vengono rimossi anche dai backup entro 90 giorni</li>
        </ul>
      `
    },
    {
      id: 6,
      title: "Sicurezza dei Dati",
      icon: Lock,
      content: `
        <p>Adottiamo misure tecniche e organizzative per proteggere i dati:</p>
        <p><strong>Misure tecniche:</strong></p>
        <ul>
          <li>Crittografia in transito (HTTPS/TLS 1.3)</li>
          <li>Crittografia a riposo per dati sensibili</li>
          <li>Autenticazione sicura con hash password</li>
          <li>Protezione contro attacchi comuni (XSS, CSRF, SQL injection)</li>
          <li>Backup regolari e ridondanza</li>
        </ul>
        <p><strong>Misure organizzative:</strong></p>
        <ul>
          <li>Accesso ai dati limitato al personale autorizzato</li>
          <li>Formazione del personale sulla sicurezza</li>
          <li>Procedure di incident response</li>
          <li>Audit periodici</li>
        </ul>
      `
    },
    {
      id: 7,
      title: "Trasferimento Dati",
      icon: Globe,
      content: `
        <p><strong>Ubicazione dei server:</strong></p>
        <p>I dati sono conservati su server ubicati nell'Unione Europea.</p>
        <p><strong>Servizi di terze parti:</strong></p>
        <p>Utilizziamo alcuni servizi di terze parti per l'erogazione del servizio:</p>
        <ul>
          <li><strong>Cloudflare</strong> (CDN e protezione) - Clausole Contrattuali Standard</li>
          <li><strong>Brevo</strong> (email transazionali) - Server in UE</li>
          <li><strong>Stripe</strong> (pagamenti) - Clausole Contrattuali Standard</li>
        </ul>
        <p>I fornitori sono selezionati in base alla conformità GDPR e utilizziamo le appropriate garanzie (Clausole Contrattuali Standard) per eventuali trasferimenti extra-UE.</p>
      `
    },
    {
      id: 8,
      title: "Diritti dell'Interessato",
      icon: Settings,
      content: `
        <p>Ai sensi degli artt. 15-22 del GDPR, l'interessato ha diritto di:</p>
        <ul>
          <li><strong>Accesso:</strong> Ottenere conferma del trattamento e copia dei dati</li>
          <li><strong>Rettifica:</strong> Correggere dati inesatti o incompleti</li>
          <li><strong>Cancellazione:</strong> Richiedere la cancellazione dei dati ("diritto all'oblio")</li>
          <li><strong>Limitazione:</strong> Limitare il trattamento in determinati casi</li>
          <li><strong>Portabilità:</strong> Ricevere i dati in formato strutturato (CSV/JSON)</li>
          <li><strong>Opposizione:</strong> Opporsi al trattamento per legittimo interesse</li>
          <li><strong>Revoca consenso:</strong> Revocare il consenso in qualsiasi momento</li>
        </ul>
        <p><strong>Come esercitare i diritti:</strong></p>
        <ul>
          <li>Dalla piattaforma: Impostazioni > Esporta i Tuoi Dati</li>
          <li>Via email: privacy@assietica.it</li>
        </ul>
        <p>Risponderemo entro 30 giorni dalla richiesta.</p>
        <p><strong>Reclamo all'Autorità:</strong></p>
        <p>L'interessato ha diritto di proporre reclamo al Garante per la Protezione dei Dati Personali (www.garanteprivacy.it).</p>
      `
    },
    {
      id: 9,
      title: "Cessazione del Servizio",
      icon: AlertTriangle,
      content: `
        <p><strong>Cosa succede quando chiudi l'account:</strong></p>
        <ol>
          <li><strong>Prima della chiusura:</strong> Puoi esportare tutti i tuoi dati (volontari, soci, documenti, contabilità) in formato ZIP</li>
          <li><strong>Periodo di grazia:</strong> I dati rimangono disponibili per 30 giorni dopo la richiesta di chiusura</li>
          <li><strong>Cancellazione:</strong> Dopo 30 giorni, i dati vengono cancellati definitivamente</li>
          <li><strong>Backup:</strong> I dati vengono rimossi dai backup entro 90 giorni</li>
        </ol>
        <p><strong>Dati conservati per obbligo di legge:</strong></p>
        <p>Alcuni dati (fatture, log di sicurezza) potrebbero essere conservati per il tempo richiesto dalla legge, in forma anonimizzata dove possibile.</p>
      `
    },
    {
      id: 10,
      title: "Uso dell'Intelligenza Artificiale (AI Act)",
      icon: Bot,
      content: `
        <p><strong>Sistemi AI utilizzati in AssieticaGest</strong></p>
        <p>Ai sensi del Regolamento UE 2024/1689 (AI Act), ti informiamo che nella piattaforma è integrato il seguente sistema di Intelligenza Artificiale:</p>
        <ul>
          <li><strong>Chatbot Assistente virtuale</strong> – Sistema AI a <em>rischio minimo</em> (Art. 50 AI Act)</li>
          <li><strong>Fornitore modello</strong>: OpenAI, L.L.C. (Stati Uniti d'America)</li>
          <li><strong>Modello utilizzato</strong>: GPT-4o-mini</li>
          <li><strong>Finalità</strong>: rispondere a domande sull'uso del gestionale basandosi sul manuale d'uso ufficiale</li>
          <li><strong>Piattaforma di integrazione</strong>: Emergent</li>
        </ul>

        <p><strong>Dati trattati dal chatbot</strong></p>
        <p>Quando interagisci con il chatbot AI vengono trattati:</p>
        <ul>
          <li>I messaggi che digiti nella chat</li>
          <li>Un identificativo di sessione anonimo (per il contesto conversazionale)</li>
          <li>Log tecnici minimi (data/ora, eventuali errori)</li>
        </ul>
        <p>I dati NON includono automaticamente le anagrafiche dei tuoi soci/volontari, salvo che tu non le inserisca manualmente nella conversazione (fortemente sconsigliato).</p>

        <p><strong>Trasferimento dati extra-UE</strong></p>
        <p>I messaggi inviati al chatbot vengono processati dai server di OpenAI, L.L.C. con sede negli Stati Uniti d'America. Il trasferimento è basato su:</p>
        <ul>
          <li>Clausole Contrattuali Standard (SCC) approvate dalla Commissione UE</li>
          <li>Data Processing Addendum (DPA) di OpenAI</li>
          <li>Adesione al Data Privacy Framework EU-US da parte di OpenAI</li>
        </ul>

        <p><strong>Conservazione conversazioni</strong></p>
        <ul>
          <li>Le conversazioni sono mantenute in memoria solo per la durata della sessione</li>
          <li>Non salviamo permanentemente lo storico chat</li>
          <li>OpenAI dichiara di NON utilizzare i dati API per addestrare i propri modelli (rif. <a href="https://openai.com/enterprise-privacy" target="_blank" rel="noreferrer">openai.com/enterprise-privacy</a>)</li>
        </ul>

        <p><strong>Base giuridica del trattamento</strong></p>
        <ul>
          <li>Art. 6(1)(b) GDPR: esecuzione di un contratto (erogazione del servizio richiesto)</li>
          <li>Art. 6(1)(f) GDPR: legittimo interesse nel fornire assistenza automatizzata</li>
        </ul>

        <p><strong>Consenso esplicito al primo utilizzo</strong></p>
        <p>Prima di iniziare la prima conversazione con il chatbot, ti viene mostrata un'informativa specifica e ti viene richiesto il consenso esplicito. Puoi revocarlo in qualsiasi momento cancellando i dati del browser o non utilizzando più il chatbot.</p>

        <p><strong>Diritti sui dati AI</strong></p>
        <p>Puoi in qualsiasi momento:</p>
        <ul>
          <li>Non utilizzare il chatbot (è funzione opzionale)</li>
          <li>Cancellare la conversazione corrente (pulsante "Nuova conversazione")</li>
          <li>Richiedere informazioni sui dati processati scrivendo a <a href="mailto:privacy@assietica.it">privacy@assietica.it</a></li>
        </ul>

        <p><strong>Limitazioni dei sistemi AI</strong></p>
        <p>Ti informiamo che:</p>
        <ul>
          <li>Le risposte del chatbot possono contenere inesattezze o essere incomplete</li>
          <li>L'AI non sostituisce il parere di un professionista qualificato (commercialista, avvocato, consulente del lavoro)</li>
          <li>Le informazioni fornite hanno valore orientativo, non ufficiale</li>
          <li>Per adempimenti normativi verifica sempre con la fonte primaria (RUNTS, Agenzia delle Entrate, ecc.)</li>
        </ul>

        <p><strong>Nessuna decisione automatizzata (Art. 22 GDPR)</strong></p>
        <p>AssieticaGest <strong>NON</strong> utilizza l'AI per prendere decisioni automatizzate che producano effetti giuridici o significativi sui tuoi soci, volontari o sull'ente. Tutte le funzionalità di gestione anagrafiche, contabilità, adempimenti sono deterministiche e sotto il tuo controllo.</p>

        <p><strong>Sistemi vietati (Art. 5 AI Act)</strong></p>
        <p>AssieticaGest non utilizza tecniche subliminali, manipolative, di scoring sociale, riconoscimento biometrico né altre pratiche vietate dall'Art. 5 dell'AI Act.</p>

        <p><strong>Per maggiori informazioni</strong></p>
        <p>Consulta la pagina dedicata <a href="/uso-intelligenza-artificiale">Uso dell'Intelligenza Artificiale</a> oppure scrivi a <a href="mailto:privacy@assietica.it">privacy@assietica.it</a>.</p>
      `
    }
  ];

  return (
    <div className="space-y-6 max-w-4xl mx-auto" data-testid="privacy-policy">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
          <Shield className="h-6 w-6" />
          Informativa Privacy
        </h1>
        <p className="text-gray-500 mt-1">
          Informativa sul trattamento dei dati personali ai sensi del GDPR
        </p>
        <p className="text-sm text-gray-400 mt-2">
          Ultimo aggiornamento: Marzo 2026
        </p>
      </div>

      {/* Intro */}
      <Card className="bg-blue-50 border-blue-200">
        <CardContent className="pt-6">
          <p className="text-blue-800">
            La presente informativa descrive come <strong>Assietica Società Cooperativa – Società Benefit</strong> raccoglie, 
            utilizza e protegge i dati personali degli utenti della piattaforma Assietica Gest, in conformità con il 
            Regolamento UE 2016/679 (GDPR) e la normativa italiana in materia di protezione dei dati personali.
          </p>
        </CardContent>
      </Card>

      {/* Sections */}
      {sections.map((section) => (
        <Card key={section.id}>
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-lg">
              <section.icon className="h-5 w-5 text-blue-600" />
              {section.id}. {section.title}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div 
              className="prose prose-sm max-w-none text-gray-700"
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          </CardContent>
        </Card>
      ))}

      {/* Contact */}
      <Card className="bg-gray-50">
        <CardContent className="pt-6">
          <h3 className="font-semibold mb-2 flex items-center gap-2">
            <Mail className="h-5 w-5" />
            Contatti Privacy
          </h3>
          <p className="text-sm text-gray-600">
            Per esercitare i tuoi diritti o per qualsiasi domanda sul trattamento dei dati:
          </p>
          <ul className="text-sm text-gray-600 mt-2">
            <li><strong>Email:</strong> privacy@assietica.it</li>
            <li><strong>Oggetto:</strong> "Richiesta Privacy - [Tuo Nome]"</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
